import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'app-confirm-prompt',
    templateUrl: './confirm-prompt.component.html',
    styleUrls: ['./confirm-prompt.component.css'],
    standalone: false
})
export class ConfirmPromptComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, message: string}, private dialogRef: MatDialogRef<ConfirmPromptComponent>) { }

  cancel(){
    this.dialogRef.close(false);
  }

  confirm(){
    this.dialogRef.close(true);
  }
}
